import { initialState } from './auth.state';
import * as authActions from './auth.actions';
import { Utente } from '../../shared/models/utente.model';

/**
 * Funzione che gestisce gli aggiornamenti di stato causati dalle azioni di autenticazione
 * @param state {State} stato relativo allo store auth e inizialmente valorizzato a initialState
 * @param action {AuthAction} le azioni disponibili per lo store auth
 */
export function authReducer(state = initialState, action: authActions.AuthAction) {
    switch(action.type) {
        case authActions.LOGIN: {
            return {
                ...state,
                isAuth: false,
                authError: null,
                loggedUser: null,
                isLoading: true
            };
        };
        case authActions.LOGIN_SUCCESS: {
            return {
                ...state,
                isAuth: true,
                authError: null,
                loggedUser: action.payload,
                isLoading:false
            };
        };
        case authActions.LOGIN_FAILURE: {
            return {
                ...state,
                isAuth: false,
                authError: action.payload,
                loggedUser: null,
                menuVoices: [],
                isLoading: false
            };
        };
        case authActions.LOGOUT: {
            return {
                ...initialState
            };
        };
        case authActions.SHOW_WARNING: {
            return {
                ...state,
                isWarning: action.payload
            };
        };
        case authActions.START_KEEPALIVE: {
            return {
                ...state,
                isWarning: false
            };
        };
        case authActions.UPDATE_LOGGEDUSER_SUCCESS: {
            let utenteAggiornato: Utente = {
                ...action.payload,
                key: state.loggedUser.key
            };
            localStorage['loggedUser'] = JSON.stringify(utenteAggiornato);
            return {
                ...state,
                loggedUser: utenteAggiornato
            };
        };
        case authActions.UPDATE_LOGGEDUSER_FAILURE: {
            return {
                ...state
            }
        }
        
        case authActions.GET_ROLES_SUCCESS: {
            return {
                ...state,
                roleTypeList: action.payload.slice()
            };
        };
        case authActions.GET_RES_TYPE_SUCCESS: {
            return {
                ...state,
                resourceTypeList: action.payload.slice()
            };
        };
        case authActions.LOADING_PAGE: {
            return {
                ...state,
                isLoading: action.payload
            }
        };
        case authActions.GET_GLOS_TYPE_SUCCESS: {
            return {
                ...state,
                glossaryTypeList: action.payload.slice()
            }
        };
        case authActions.GET_NOTE_TYPE_SUCCESS: {
            return {
                ...state,
                noteTypeList: action.payload
            };
        };
        case authActions.GET_ATTACHMENT_TYPES_SUCCESS: {
            return {
                ...state,
                attachmentTypeList: action.payload
            }
        };
        case authActions.GET_ASSIGNED_RESOURCES_SUCCESS: {
            return {
                ...state,
                assignedResources: action.payload.slice()
            }
        };
        case authActions.GET_TEMPORARY_SUCCES: 
        case authActions.POST_TEMPORARY_SUCCES: {
            return {
                ...state,
                notePersonali: action.payload
            };
        };
        default: {
            return {
                ...state
            };
        };
    }
}